// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

import { ResourcesConfig } from "aws-amplify";

const config: ResourcesConfig =  {
    API: {
        GraphQL: {
          endpoint: 'https://zbifolbkcna6jgut3xetn6r5ji.appsync-api.eu-west-1.amazonaws.com/graphql',
          region: 'eu-west-1',
          defaultAuthMode: 'apiKey',
          apiKey: 'da2-cxiz6f6k2jds5mz5nspog5hnua'
        }
    }
};

export default config;